import { useMutation } from 'react-query';
import { getWorkOrderFinancialReceipt } from './WorkOrderFinancialReceipt.services';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { AxiosError } from 'axios';
import arrayBufferParse from '@/utils/functions/arrayBufferParse';

interface Report {
  timestamp: string;
  status: number;
  error: string;
  path: string;
  message: string;
}

export function useWorkOrderFinancialReceiptReport() {
  return useMutation(getWorkOrderFinancialReceipt, {
    onSuccess() {
      notification.success({
        message: 'Recibo de parcelas emitido com sucesso!',
      });
    },

    onError(error: AxiosError<Report>) {
      const response = arrayBufferParse<Report>(error.response?.data);

      notificationError(response);
    },
  });
}
